import SearchIcon from '@mui/icons-material/Search'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'

interface QuickSearchEmptyStateProps {
  title: string;
  subtitle: string;
}

export default function QuickSearchEmptyState(props: QuickSearchEmptyStateProps): JSX.Element {
  const { title, subtitle } = props

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8, px: 3 }}>
      <SearchIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.disabled">
        {subtitle}
      </Typography>
    </Box>
  )
}
